var truncate = function () {

	var elements = document.querySelectorAll('[data-truncate]');

	function init() {

		if (!elements.length) return;

		for (var i = 0; i < elements.length; i++) {
			(function (i) {

				setup(elements[i]);

			}).call(this, i);
		}

	}

	function setup(element) {

		var inner = element.querySelector('[data-truncate-inner]');

		if (element.offsetHeight >= inner.scrollHeight) return;

		var readMoreText = element.getAttribute('data-truncate-more-text');
		var readLessText = element.getAttribute('data-truncate-less-text');

		element.insertAdjacentHTML('afterend', '<p class="c-truncate-more" data-truncate-more><button data-truncate-more-button class="c-truncate-more__button">' + readMoreText + '</button></p>');

		var moreButton = element.nextSibling.querySelector('[data-truncate-more-button]');

		moreButton.addEventListener('click', function (e) {

			handleMoreClick(element, moreButton, readMoreText, readLessText);
			e.preventDefault();

		});

	}

	function handleMoreClick(element, moreButton, readMoreText, readLessText) {

		var isOff = element.getAttribute('data-truncate') === 'off';

		var moreButtonText = isOff ? readMoreText : readLessText;
		moreButton.innerHTML = moreButtonText;
		moreButton.setAttribute('data-truncate-more-button', (isOff ? '' : 'expanded'));

		element.setAttribute('data-truncate', (isOff ? '' : 'off'));

  }

	return {
		init: init
	};

}();

$(function () { truncate.init(); });